<script setup lang="ts">
import { useGetMe } from "@/auth/useMe";
import { usePermissions } from "@/auth/usePermissions";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { formatDatetime } from "@/utils/toFormattedDatetime";
import { Download, Group, MessageText } from "@iconoir/vue";
import { useGetHouses } from "./housesCrud";
import { useFilter } from "./useHouseFilter";

const { houses, getHousesStatus } = useGetHouses();
const { me } = useGetMe();
const { canAccess } = usePermissions(me);
const { query, filteredHouses, hasDetails } = useFilter(houses);
</script>

<template>
  <ManagementLayout>
    <template #header>
      <div class="multi-columns">
        <div class="column">
          <h1>Häuser</h1>
          <a
            v-if="canAccess('export')"
            href="/export/houses.csv"
            download
            role="button"
            class="button"
          >
            <Download /> alle Häuser runterladen (.csv)
          </a>
        </div>
        <div class="filter-form">
          <form class="column" @submit.prevent>
            <label for="search" class="visually-hidden"
              >Suche nach Adresse</label
            >
            <input
              id="search"
              v-model="query.search"
              type="text"
              placeholder="Suche nach Adresse"
            />
            <div>
              <label for="with-details" class="visually-hidden"
                >Detail Status</label
              >
              <select
                id="status"
                v-model="query.withDetails"
                name="with-details"
              >
                <option :value="null">alle Häuser</option>
                <option :value="true">Häuser mit Details zur Adresse</option>
                <option :value="false">Häuser ohne Details zur Adresse</option>
              </select>
            </div>
          </form>
        </div>
      </div>
    </template>

    <HandleQueryStatus :query-status="getHousesStatus">
      <table>
        <thead>
          <tr>
            <th>Adresse</th>
            <th><Group /> Kontakte</th>
            <th><MessageText /> Details zur Adresse</th>
            <th>zuletzt aktualisiert</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="house in filteredHouses" :key="house.id">
            <td>
              <RouterLink
                :to="{
                  name: 'editHouse',
                  params: { houseId: house.id },
                }"
                class="column--primary-action"
              >
                {{ house.street }} {{ house.houseNumber }}
              </RouterLink>
            </td>
            <td>{{ house.contactsCount }}</td>
            <td>{{ hasDetails(house) ? "vorhanden" : "n/a" }}</td>
            <td>
              {{ formatDatetime(house.updatedAt) }}
            </td>
            <td class="actions">
              <EditLink
                :to="{ name: 'editHouse', params: { houseId: house.id } }"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </HandleQueryStatus>
  </ManagementLayout>
</template>

<style scoped>
.filter-form {
  align-self: end;
}
</style>
